import styled from "styled-components";

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const Box = styled.div`
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 96%;
  padding: 8px;
  margin-bottom: 16px;
  border-radius: 10px;
  background-color: #fff;
`;

export const InfoBoxWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

export const InfoBox = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-inline: 8px 8px;

  @media screen and (max-width: 365px) {
    padding-inline: 8px 5px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;

  .ant-btn-default {
    width: 205px;
    height: 56px;
    background: ${(props) => props.theme.white} !important;
    color: ${(props) => props.theme.textColor} !important;
    display: flex;
    justify-content: center;
    align-items: center;

    :hover {
      background: ${(props) => props.theme.white} !important;
      color: ${(props) => props.theme.textColor} !important;
      border: none;
    }

    :disabled {
      background-color: #fff !important;
    }
  }

  .ant-btn-primary {
    :disabled {
      background: #fff !important;
    }
  }
`;

export const ActionLabel = styled.div`
  padding-top: 16px;
  font-size: 12px;
  font-weight: 500;
  color: #71207c;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageBox = styled.div`
  display: flex;
  align-items: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 60px;
  border-radius: 12px;
  @media screen and (max-width: 350px) {
    width: 35px;
  }
  @media screen and (max-width: 310px) {
    width: 30px;
  }
`;

export const TypeText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #000000;

  @media screen and (max-width: 310px) {
    font-size: 11px;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.textColor};
  text-align: center;
  padding-top: 4px;

  @media screen and (max-width: 350px) {
    font-size: 12px;
  }
  @media screen and (max-width: 310px) {
    font-size: 11px;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.dark2};
  text-align: center;

  @media screen and (max-width: 350px) {
    font-size: 11px;
  }
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #e1cce0;
  height: 55px;
`;

export const EmptyCard = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const SelectAccountTitle = styled.div`
  color: ${(props) => props.theme.textColor};
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 13px;
  text-align: center;
`;
